//
// Haelt die Web-App auf dem neuesten Stand.
//
// Der Server liefert die index.html mit `Cache-Control: no-cache`, ein Reload
// genuegt also fuer die neue Version. Trotzdem - gerade auf iOS, und dort
// wiederum in der installierten Home-Screen-PWA - bleibt oft tagelang dieselbe
// Seite offen. Deshalb fragt die App hier bei jedem Sichtbarwerden die
// Build-Kennung ab (`/api/version`) und bietet bei einem neuen Stand ein
// Popup zum Neuladen an.
import { request } from './api';

let currentHash: string | null = null;

/** Aktuelle Build-Kennung - null, solange der erste Abruf laeuft. */
export function versionHash(): string | null {
  return currentHash;
}

/**
 * Prueft, ob der Server einen anderen Stand ausliefert als die laufende Seite.
 * `true` nur bei einem gesicherten Befund - bei einem Fehler bleibt die App,
 * wie sie ist, kein Popup wegen eines toten Netzes.
 */
export async function updateAvailable(): Promise<boolean> {
  try {
    const { hash } = await request<{ hash: string }>('/api/version');
    if (currentHash === null) {
      currentHash = hash;
      return false;
    }
    return hash !== currentHash;
  } catch {
    return false;
  }
}
